<style lang="scss" scoped>
@import "@/assets/scss/_variables.scss";

#fieldset {
  width: 100%;
  padding-top: 10px;
  background: $white;
}

.filter-bar {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-end;
  gap: 16px;
  row-gap: 12px;
  margin-bottom: 20px;
}

.filter-item {
  flex: 0 0 auto;
  min-width: 0;
}

.filter-item label {
  display: block;
  margin-bottom: 4px;
  white-space: nowrap;
}

.selector {
  min-width: 150px;
  max-width: 220px;
  width: 100%;
}

.multiformat-checkbox {
  display: inline;
}

.multiformat-item {
  display: flex;
  align-items: center;
  gap: 8px;
  padding-bottom: 6px;
}

.action-buttons {
  display: flex;
  align-items: center;
  gap: 8px;
  padding-bottom: 6px;
}

.share-item {
  display: flex;
  align-items: center;
  padding-bottom: 6px;
  position: relative;
}

.displayContainer {
  gap: 32px;
  padding: 16px;
}

.carouselContainer {
  height: fit-content;
  gap: 16px;
}

.share-button {
  width: calc(1.5em + 0.75rem + 2px);
  z-index: 4;
  position: relative;
}

.carouselControls {
  gap: 8px;
  width: 180px;
}

.selectorFormat {
  width: 120px;
}

.carouselArrow {
  max-width: 16px;
  cursor: pointer;
}

.backdrop {
  top: 0;
  left: 0;
  opacity: 0.5;
  background: $white;
  cursor: pointer;
  z-index: 2;
}
</style>

<template>
  <div
    class="margin-top-content"
    :style="displayModal && { width: '65%' }"
    :class="!displayModal && 'main-margins mx-auto'"
  >
    <b-form-group id="fieldset">
      <div class="filter-bar">
        <div class="filter-item">
          <label for="creativeSetSelect">Creative Set</label>
          <b-form-select
            id="creativeSetSelect"
            class="selector"
            v-model="selectedCreativeSetId"
            :options="creativeSetOptions"
            @change="changeCreativeSet"
          ></b-form-select>
        </div>

        <div class="filter-item d-flex align-items-end">
          <div>
            <label for="selectMarket">Market</label>
            <b-form-select
              id="selectMarket"
              class="selector"
              v-model="selectedMarket"
              :options="marketsOptions"
              :disabled="!selectedCreativeSet || loadingMarket"
              @change="changeMarket"
            ></b-form-select>
          </div>
          <b-spinner class="ml-2 mb-2" small label="Loading..." v-if="loadingMarket"></b-spinner>
        </div>

        <div class="filter-item">
          <label for="selectMessage">Message</label>
          <b-form-select
            id="selectMessage"
            class="selector"
            v-model="selectedMessage"
            :options="messagesOptions"
            :disabled="!selectedCreativeSet || loadingMessage"
            @change="changeMessage"
          ></b-form-select>
        </div>

        <div class="filter-item multiformat-item">
          <b-form-checkbox
            id="multiformat-checkbox"
            class="multiformat-checkbox"
            v-model="multiformatsCheckboxStatus"
            name="multiformat-checkbox"
            :value="true"
            :unchecked-value="false"
            :disabled="!selectedMarket || !selectedMessage"
          ></b-form-checkbox>
          <label for="multiformat-checkbox" class="mb-0">Multi-format</label>
        </div>

        <div class="filter-item action-buttons">
          <b-btn
            class="border-primary color-primary"
            variant="creativeLibrary"
            size="sm"
            v-if="selectedMarket && selectedMessage && !multiformatsCheckboxStatus"
            @click="replayCreative"
            >Replay
          </b-btn>
          <b-btn
            variant="creativeLibrary"
            class="border-primary color-primary"
            size="sm"
            v-if="selectedMarket && selectedMessage && multiformatsCheckboxStatus"
            @click="replayCreatives"
            >Replay All
          </b-btn>
        </div>

        <div class="filter-item share-item">
          <div
            class="d-flex align-items-center"
            @click="displayShareModal = !displayShareModal"
            style="cursor: pointer"
          >
            <p class="m-0">Share</p>
            <img class="share-button ml-2" src="../assets/images/share.svg" />
          </div>
          <ShareModal
            v-if="displayShareModal"
            :share-link="shareLink"
            :market-options="marketsOptions"
            :creativesets-options="creativeSetOptions"
            :creative-sets="creativeSets"
            :disabled="!selectedCreativeSet || loadingMarket"
            :creative-set-id="selectedCreativeSetId"
            :user="user"
            :selected-market-prop="selectedMarket"
            :loading-market="loadingMarket"
            @update-share-link="updateShareLink"
            @close-modal="displayShareModal = !displayShareModal"
          />
        </div>
      </div>
      <div
        class="backdrop position-fixed w-100 h-100"
        v-if="displayShareModal"
        @click="displayShareModal = false"
      ></div>
    </b-form-group>
    <div v-if="!initReady && selectedMessage">
      <b-spinner label="Loading creative..."></b-spinner>
    </div>
    <div
      class="creativeContainer d-flex align-items-center flex-column"
      v-if="selectedCreativeSet && selectedMarket && selectedMessage && initReady"
    >
      <div class="carouselControls d-flex justify-content-center mb-3" v-if="!multiformatsCheckboxStatus">
        <img class="carouselArrow" src="../assets/images/arrow.svg" @click="carouselPrev()" />
        <b-form-select
          class="selectorFormat"
          v-model="selectedFormat"
          :options="formatOptions"
          @change="updateSelectedFormat(true)"
        ></b-form-select>
        <img
          class="carouselArrow"
          style="transform: rotate(180deg)"
          src="../assets/images/arrow.svg"
          @click="carouselNext()"
        />
      </div>
      <div
        class="displayContainer d-flex flex-wrap justify-content-center align-items-end"
        v-if="multiformatsCheckboxStatus"
      >
        <div class="display" v-for="format in formats" :key="format.name">
          <BannerPreview
            id="preview"
            :format="format"
            :init-data="getInitData(format.name)"
            :multi-format="multiformatsCheckboxStatus"
            ref="creatives"
            @update-url="reloadIframe"
            @open-modal="editMessage"
            :has-edit="true"
          />
        </div>
      </div>
      <div class="carouselContainer d-flex flex-column align-items-center w-100">
        <div class="flex-grow-1 d-flex flex-column justify-content-center">
          <BannerPreview
            :format="formatSelected"
            :init-data="getInitData(formatSelected.name)"
            :multi-format="multiformatsCheckboxStatus"
            @update-url="reloadIframe"
            @open-modal="editMessage"
            :has-edit="true"
          />
        </div>
      </div>
    </div>
    <Transition name="slide-fade">
      <EditMessage
        v-if="displayModal && selectedMarket && selectedMessage"
        @close-modal="close"
        @submit="submit"
        @preview="preview"
        :size="currentFormat.size"
        :type="formats.find((el) => el.name === currentFormat.size).type"
        :cta-names-table="
          dataInDb ? ctaNamesFromDb : (ctaSpreadsheet['CTA_list'] && ctaSpreadsheet['CTA_list'].rows) || []
        "
        :assets-lang-table="assetsLangRows"
        :assets-design-table="assetsDesignRows"
        :market="selectedMarket"
        :message="selectedMessage"
        :loading="loadingSave"
        :data-in-db="dataInDb"
        :init-data="initDataMap[this.selectedMarket + this.selectedMessage + currentFormat.size]"
      />
    </Transition>
    <Adblock />
  </div>
</template>

<script>
import CreativeSet from "@/domain/CreativeSet";
import BackEndpoints from "@/router/endpoints/BackEndpoints";
import CreativeSetService from "@/services/CreativeSetService";
import SpreadsheetService from "@/services/SpreadsheetService";
import ToastService from "@/services/ToastService";
import ErrorUtils from "@/utils/ErrorUtils";
import BannerPreview from "@/views/liveEdit/BannerPreview";
import ShareModal from "@/views/liveEdit/ShareModal.vue";
import axios from "axios";
import Adblock from "./liveEdit/Adblock.vue";
import EditMessage from "./liveEdit/EditMessage.vue";

export default {
  name: "LiveEdit",
  title: "Creative Library - Disneyland CMP",
  props: ["user"],
  data() {
    return {
      loadingSave: false,
      loadingMarket: false,
      loadingMessage: true,
      displayShareModal: false,
      shareLink: "",
      formats: CreativeSet.formatList,
      initDataMap: {},
      initReady: false,
      jsonAssets: [],

      multiformatsCheckboxStatus: false,
      creativeSets: [],
      selectedCreativeSetId: this.creativeSetId || null,
      creativeSetOptions: [{ value: null, text: "Select a creative set" }],

      selectedMarket: null,

      marketsOptions: [{ value: null, text: "Select a market" }],

      selectedMessage: null,
      messagesOptions: [{ value: null, text: "Select a message" }],

      selectedFormat: 0,
      formatOptions: [],

      displayModal: false,
      currentFormat: {
        size: "",
        type: "",
      },

      spreadsheet: [],
      ctaSpreadsheet: [],
      ctaNamesFromDb: [],

      previewInitData: null,
      originalInitData: null,
    };
  },

  components: {
    ShareModal,
    BannerPreview,
    EditMessage,
    Adblock,
  },
  computed: {
    creativeSetId() {
      return this.$route.params.creativeSetId;
    },
    selectedCreativeSet() {
      return this.creativeSets.find((creativeSet) => {
        return creativeSet.id === this.selectedCreativeSetId;
      });
    },
    frameInitDataPreview() {
      return this.previewInitData?.data.frames.frame1.data;
    },
    globalInitDataPreview() {
      return this.previewInitData?.data.global;
    },
    originalInitDataFrames() {
      return this.originalInitData.data.frames.frame1.data;
    },
    originalInitDataGlobal() {
      return this.originalInitData.data.global;
    },
    dataInDb() {
      return this.selectedCreativeSet?.dataInDb || false;
    },
    formatSelected() {
      return this.formats[this.selectedFormat];
    },
    assetsLangRows() {
      return this.dataInDb ? null : this.spreadsheet["Assets_lang"].rows;
    },
    assetsDesignRows() {
      return this.dataInDb ? null : this.spreadsheet["Assets_design"].rows;
    },
    creativeSet() {
      return this.creativeSets.find((cs) => {
        cs.id === this.creativeSetId;
      });
    },
  },
  methods: {
    async updateShareLink(values) {
      if (values.shareMode === "All") {
        this.shareLink = await CreativeSetService.getShareUrl();
      } else if (values.shareMode === "Market") {
        if (values.selectedMarketOnly) {
          this.shareLink = await CreativeSetService.getShareUrl(values.selectedMarketOnly);
        } else {
          this.shareLink = "";
        }
      } else if (values.shareMode === "MarketAndCreativeSet") {
        if (values.selectedMarketMC && values.selectedCreativeSetMC) {
          this.shareLink = await CreativeSetService.getShareUrl(values.selectedMarketMC, values.selectedCreativeSetMC);
        } else {
          this.shareLink = "";
        }
      }
    },
    getInitData(size) {
      return JSON.stringify(
        this.previewInitData
          ? this.previewInitData
          : this.initDataMap[this.selectedMarket + this.selectedMessage + size]
      );
    },
    getInitialInitData(size) {
      let initData = this.initDataMap[this.selectedMarket + this.selectedMessage + size];

      return JSON.stringify(initData);
    },
    changeCreativeSet() {
      this.refreshUrl();
      this.messagesOptions = [{ value: null, text: "Select a message" }];
      this.marketsOptions = [{ value: null, text: "Select a market" }];
      this.selectedMarket = null;
      this.selectedMessage = null;
      if (this.selectedCreativeSetId && this.dataInDb) {
        this.readCreativeSetDb();
      } else if (this.selectedCreativeSetId) {
        this.readCreativeSetSheet();
      }

      console.log("changeCreativeSet");
    },
    changeMarket() {
      this.previewInitData = null;
      this.messagesOptions = [{ value: null, text: "Select a message" }];
      this.selectedMessage = null;

      this.$router.push({
        query: {
          market: this.selectedMarket,
        },
      });
      console.log("changeMarket");

      this.getMessages();
    },
    async changeMessage() {
      this.previewInitData = null;
      this.initReady = false;

      if (this.dataInDb && this.selectedMarket && this.selectedMessage) {
        this.initDataMap = {};
        const resp = await axios.get(BackEndpoints.getCreativeSetAssets, {
          params: {
            creativeSetId: this.creativeSetId,
            marketName: this.selectedMarket,
            messageName: this.selectedMessage,
          },
        });

        const assets = resp.data.jsonAssets;

        assets.forEach((asset) => {
          this.initDataMap[asset.market + asset.message + asset.size] = {
            data: this.addEmptyUrlProperty(asset.initData),
            env: { name: "disneyland-cmp-banner-validation" },
          };
        });
      } else {
        this.initReady = true;
      }

      const currentRouteQuery = this.$route.query;
      if (currentRouteQuery.market !== this.selectedMarket || currentRouteQuery.message !== this.selectedMessage) {
        await this.$router.push({
          query: {
            market: this.selectedMarket,
            message: this.selectedMessage,
          },
        });
      }
      await this.fetchVariantsForCurrentFormat();
      this.initReady = true;
    },
    replay() {
      if (this.multiformatsCheckboxStatus) {
        this.replayCreatives();
      } else {
        this.replayCreative();
      }
    },
    updateSelectedFormat(replay = false) {
      const previousFormat = this.currentFormat.size;
      this.currentFormat = { size: this.formatOptions[this.selectedFormat].text, type: this.formatSelected.type };
      if (previousFormat && previousFormat !== this.currentFormat.size) {
        this.previewInitData = null;
      }
      this.fetchVariantsForCurrentFormat();
      if (replay) {
        this.replay();
      }
    },
    async fetchVariantsForCurrentFormat() {
      if (!this.dataInDb || !this.selectedCreativeSetId || !this.selectedMarket) return;

      const size = this.currentFormat.size;

      const resp = await axios.get(BackEndpoints.getVariantsByBundleMarketAndSize, {
        params: {
          bundleName: "cta",
          market: this.selectedMarket,
          size: size,
        },
      });

      this.ctaNamesFromDb = resp.data;
    },
    carouselPrev() {
      if (this.selectedFormat === 0) {
        this.selectedFormat = this.formats.length - 1;
      } else {
        this.selectedFormat--;
      }
      this.updateSelectedFormat(true);
    },
    carouselNext() {
      if (this.selectedFormat === this.formats.length - 1) {
        this.selectedFormat = 0;
      } else {
        this.selectedFormat++;
      }
      this.updateSelectedFormat(true);
    },
    changePreviewInitData() {
      if (this.previewInitData) {
        const parsedPreviewInitData = this.previewInitData;
        const parsedOriginalInitData = JSON.parse(this.getInitialInitData(this.currentFormat.size));
        this.previewInitData = {
          data: {
            frames: { ...parsedPreviewInitData.data.frames },
            global: {
              ...parsedOriginalInitData.data.global,
              logoTransform: parsedPreviewInitData.data.global.logoTransform,
              videoTransform: parsedPreviewInitData.data.global.videoTransform,
            },
          },
          env: {
            name: "disneyland-cmp-banner-validation",
          },
        };
      }
    },

    refreshUrl() {
      this.$router.push({
        name: "LiveEditPreselect",
        params: { creativeSetId: this.selectedCreativeSetId },
      });
    },
    reloadIframe(formatName) {
      const format = this.formats.find((el) => el.name === formatName);
      format.updateUrl();
    },
    replayCreative() {
      const format = this.formatSelected;
      format.updateUrl();
    },
    replayCreatives() {
      this.$refs.creatives.forEach((element) => element.refresh());
    },
    addEmptyUrlProperty(initD) {
      const initData = JSON.parse(initD);
      initData.frames.frame1.data.url = "";
      return initData;
    },
    async readCreativeSetSheet() {
      this.loadingMarket = true;
      this.loadingMessage = true;
      this.initDataMap = {};
      SpreadsheetService.setToken(this.user.oAuthAccessToken);

      this.ctaSpreadsheet = await SpreadsheetService.getSheets(
        ["CTA_list", "CTAStyle_list"],
        SpreadsheetService.CTA_SPREADSHEET_ID
      );

      this.spreadsheet = await SpreadsheetService.getSheets(
        ["scenarios", "Assets_lang", "Assets_design"],
        this.selectedCreativeSet.spreadsheetId
      );

      try {
        if (!this.spreadsheet.scenarios.headers.includes(SpreadsheetService.SCENARIO_COL)) {
          throw Error("No column #scenario found.");
        }
        if (!this.spreadsheet.scenarios.headers.includes(SpreadsheetService.SIZE_COL)) {
          throw Error("No column #size found.");
        }

        if (!this.spreadsheet.scenarios.headers.includes(SpreadsheetService.INITDATA_COL)) {
          throw Error("No column json found.");
        }
      } catch (error) {
        ToastService.error("Error", `Error parsing spreadsheet headers :${ErrorUtils.getMessage(error)}`);
      }

      this.spreadsheet.scenarios.rows.forEach((row) => {
        const scenario = row[SpreadsheetService.SCENARIO_COL];
        const initDataT = row[SpreadsheetService.INITDATA_COL];
        const size = row[SpreadsheetService.SIZE_COL];
        const [market, message] = scenario.split("*");

        if (!this.marketsOptions.some((element) => element.value === market)) {
          this.marketsOptions.push({
            value: market,
            text: market,
          });
        }

        this.initDataMap[market + message + size] = {
          data: this.addEmptyUrlProperty(initDataT),
          env: {
            name: "disneyland-cmp-banner-validation",
          },
        };
      });

      this.loadingMarket = false;
    },
    async readCreativeSetDb() {
      this.loadingMarket = true;
      this.marketsOptions = [{ value: null, text: "Select a market" }];
      this.messagesOptions = [{ value: null, text: "Select a message" }];
      this.selectedMarket = null;
      this.selectedMessage = null;
      this.initDataMap = {};

      const cs = this.creativeSets.find((cs) => cs.id === this.creativeSetId);

      cs.creativeSetMarkets
        .filter((csm) => {
          return csm.enabled;
        })
        .sort((a, b) => a.market.name.localeCompare(b.market.name))
        .forEach((csm) => {
          this.marketsOptions.push({ value: csm.market.name, text: csm.market.name });
        });
      this.loadingMarket = false;
    },
    async getMessages() {
      if (this.selectedCreativeSetId && this.selectedMarket) {
        this.loadingMessage = true;
        this.messagesOptions = [{ value: null, text: "Select a message" }];

        if (this.dataInDb) {
          this.initDataMap = {};
          const resp = await axios.get(BackEndpoints.getMessagesByMarket, {
            params: {
              creativeSetId: this.creativeSetId,
              marketName: this.selectedMarket,
            },
          });

          const messages = resp.data.messages;
          messages.forEach((message) => {
            this.messagesOptions.push({ value: message, text: message });
          });
        } else {
          this.spreadsheet.scenarios.rows.forEach((row) => {
            const scenario = row[SpreadsheetService.SCENARIO_COL];
            const initDataT = row[SpreadsheetService.INITDATA_COL];
            const size = row[SpreadsheetService.SIZE_COL];
            const [market, message] = scenario.split("*");

            if (market === this.selectedMarket) {
              if (!this.messagesOptions.find((element) => element.value === message)) {
                this.messagesOptions.push({
                  value: message,
                  text: message,
                });
              }
            }

            this.initDataMap[market + message + size] = {
              data: this.addEmptyUrlProperty(initDataT),
              env: {
                name: "disneyland-cmp-banner-validation",
              },
            };
          });
        }

        this.loadingMessage = false;
      }
    },
    editMessage(size, type, initdata) {
      this.displayModal = true;
      this.currentFormat = { size: size, type: type };

      this.selectedFormat = this.formatOptions.find((el) => el.text === size).value;
      this.originalInitData = initdata;
      this.multiformatsCheckboxStatus = false;
    },
    close() {
      this.displayModal = false;
      this.previewInitData = null;
      this.replay();
    },
    getLogoInitData() {
      const logo = this.originalInitDataGlobal.logo;
      const lastIndex = logo.lastIndexOf("/");
      return logo.slice(lastIndex + 1);
    },

    formatBackground() {
      if (
        this.originalInitDataGlobal.background.includes(".jpg") ||
        this.originalInitDataGlobal.background.includes(".png") ||
        this.originalInitDataGlobal.background.includes(".svg") ||
        this.originalInitDataGlobal.background.includes(".jpeg") ||
        this.originalInitDataGlobal.background.includes(".gif")
      ) {
        const nameFile = this.originalInitDataGlobal.background.split("background/")[1].split("/")[0];
        const extension = this.originalInitDataGlobal.background.split(".").pop();

        return `${nameFile}.${extension}`;
      } else {
        return this.originalInitDataGlobal.background;
      }
    },
    async submit(values) {
      if (!values.ctaStyle && !this.dataInDb) {
        ToastService.error("Error", `Error because CTA style is empty`);
        return;
      }
      this.loadingSave = true;
      if (!this.dataInDb) {
        // Mode spreadsheet
        const params = {
          market: this.selectedMarket,
          message: this.selectedMessage,
          size: this.currentFormat.size,
        };
        const dataLang = {
          tagline: values.text,
          offer: values.offer,
          cta: values.cta,
          ml: values.terms,
          ctaStyle: values.ctaStyle,
        };
        const dataDesign = {
          colorTxt: this.originalInitDataFrames.colorTxt,
          bgCta: this.originalInitDataFrames.bgCta,
          colorCta: this.originalInitDataFrames.colorCta,
          colorCopyright: this.originalInitDataGlobal.colorCopyright,
          logo: this.getLogoInitData(),
          background: this.formatBackground(),
          logoTransform: `translate(${values.logoTransform.x}px,${values.logoTransform.y}px) scale(${values.logoTransform.scale}%)`,
          videoTransform: `translate(${values.videoTransform.x}px,${values.videoTransform.y}px)`,
        };
        const payload = {
          gssid: this.selectedCreativeSet.spreadsheetId,
          market: this.selectedMarket,
          message: this.selectedMessage,
          size: this.currentFormat.size,
        };

        try {
          await SpreadsheetService.batchUpdateValues(
            this.selectedCreativeSet.spreadsheetId,
            params,
            dataLang,
            dataDesign
          );
          await axios.get(BackEndpoints.update, { params: payload });
          await this.readCreativeSetSheet();
          ToastService.success("Success", `The spreadsheet has been updated`);
        } catch (error) {
          ToastService.error("Error", `Error on save : ${ErrorUtils.getMessage(error)}`);
        } finally {
          this.previewInitData = null;
          this.loadingMessage = false;
          this.loadingSave = false;
          this.replay();
        }
      } else {
        // Mode base de données
        try {
          const payload = {
            creativeSetId: this.selectedCreativeSetId,
            market: this.selectedMarket,
            message: this.selectedMessage,
            size: this.currentFormat.size,
            design: this.currentFormat.type,
            initData: JSON.stringify(this.previewInitData?.data),
          };
          await axios.post(BackEndpoints.saveInitDataToDb, payload);
          await this.changeMessage();
          ToastService.success("Success", `The data has been saved to database.`);
        } catch (error) {
          ToastService.error("Error", `Error on DB save: ${ErrorUtils.getMessage(error)}`);
        } finally {
          this.previewInitData = null;
          this.loadingSave = false;
          this.replay();
        }
      }
    },

    preview(values) {
      if (!values.ctaStyle && !this.dataInDb) {
        ToastService.error("Error", `Error because CTA style is empty`);
      } else {
        this.previewInitData = this.originalInitData;
        this.frameInitDataPreview.txt1 = this.formatText(values.text);
        this.frameInitDataPreview.txt2 = this.formatText(values.offer);
        this.frameInitDataPreview.terms = this.formatText(values.terms);
        if (this.dataInDb) {
          this.frameInitDataPreview.cta = this.formatText(values.cta);
          this.frameInitDataPreview.borderCta = values.borderCta;
          this.frameInitDataPreview.borderRadiusCta = values.borderRadiusCta;
        } else {
          this.frameInitDataPreview.cta = this.formatText(this.convertDataCta(values.cta, values.ctaStyle));
          this.frameInitDataPreview.borderCta = this.getCtaStyle(values.ctaStyle, "borderCta");
          this.frameInitDataPreview.borderRadiusCta = this.getCtaStyle(values.ctaStyle, "borderRadiusCta");
        }
        this.globalInitDataPreview.logoTransform = `translate(${values.logoTransform.x}px,${values.logoTransform.y}px) scale(${values.logoTransform.scale}%)`;
        this.globalInitDataPreview.videoTransform = `translate(${values.videoTransform.x}px,${values.videoTransform.y}px)`;
        this.updateSelectedFormat();
        this.changePreviewInitData();
        this.replay();
      }
    },

    convertDataCta(ctaName, ctaStyle) {
      const findByName = this.ctaSpreadsheet.CTA_list.rows.find(
        (el) =>
          el["#Size Category"] === this.currentFormat.size &&
          el["#Cta style"] === ctaStyle &&
          el["#Cta list"] === ctaName &&
          el["lang"].includes(this.selectedMarket)
      );
      if (!findByName) {
        const findByType = this.ctaSpreadsheet.CTA_list.rows.find(
          (el) =>
            el["#Size Category"] === this.currentFormat.type &&
            el["#Cta style"] === ctaStyle &&
            el["#Cta list"] === ctaName &&
            el["lang"].includes(this.selectedMarket)
        );
        return findByType["cta result"];
      } else {
        return findByName["cta result"];
      }
    },

    getCtaStyle(type, style) {
      const findByType = this.ctaSpreadsheet.CTAStyle_list.rows.find(
        (el) => el["size"] === this.currentFormat.type && el["type"] === type
      );
      return findByType[style];
    },

    formatText(text) {
      if (
        text.indexOf(".jpg") > -1 ||
        text.indexOf(".jpeg") > -1 ||
        text.indexOf(".svg") > -1 ||
        text.indexOf(".png") > -1 ||
        text.indexOf(".gif") > -1
      ) {
        return text;
      } else {
        return text.replace(/_/g, "&nbsp;");
      }
    },
  },
  watch: {
    selectedMessage(message) {
      if (!message) {
        this.displayModal = false;
      } else {
        this.currentFormat = { size: this.formatSelected.name, type: this.formatSelected.type };
        this.getInitData(this.currentFormat.size);
        this.previewInitData = null;
        this.replay();
      }
    },
    selectedMarket(market) {
      if (!market) {
        this.displayModal = false;
      }
    },
    multiformatsCheckboxStatus() {
      if (this.multiformatsCheckboxStatus) this.displayModal = false;
    },
  },
  async mounted() {
    await SpreadsheetService.initClient();

    this.creativeSets = await CreativeSetService.list();

    if (this.creativeSetId) {
      this.selectedCreativeSetId = this.creativeSetId;
    }

    this.creativeSets.forEach((el) => {
      this.creativeSetOptions.push({ value: el.id, text: el.name });
    });

    this.formats.forEach((format, index) => {
      this.formatOptions.push({ value: index, text: format.name });
    });

    if (this.selectedCreativeSetId && this.dataInDb) {
      await this.readCreativeSetDb();
    } else if (this.selectedCreativeSetId) {
      await this.readCreativeSetSheet();
    }

    if (this.$route.query.market) {
      this.selectedMarket = this.$route.query.market;
      await this.getMessages();
      const urlMessageOption = this.messagesOptions.find((message) => message.value === this.$route.query.message);

      if (urlMessageOption) {
        this.selectedMessage = urlMessageOption.value;
        await this.changeMessage();
      } else {
        console.warn("Message from route not found in messagesOptions");
      }
    }
  },
};
</script>
